import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTypography = styled(Typography)({
  lineHeight: 1.39,
  marginBottom: 10
});

export default StyledTypography;
